import * as React from 'react';

import { enumBookingStatus } from '@rematter/frontend-lib-api-client';

import { BookingRecord } from '../../types/booking';
import { LoadsTab } from '../_shared/LoadsTab/LoadsTab';

import { BookingVoyageTracker } from './BookingVoyageTracker';

type Props = {
  booking: BookingRecord;
  disableAddLoad?: boolean;
};

export const BookingTabLoads: React.FC<Props> = ({
  booking,
  disableAddLoad = false,
}) => {
  const showVoyageTracker =
    booking.status === enumBookingStatus.Shipped ||
    booking.status === enumBookingStatus.Completed;

  return (
    <div className="@BookingTabLoads flex h-full flex-col gap-4">
      {showVoyageTracker && (
        <BookingVoyageTracker
          bookingId={booking.id}
          loadStatusSummary={booking.loadStatusSummary}
        />
      )}
      <LoadsTab
        bookingId={booking.id}
        entityType="booking"
        disableAddLoad={disableAddLoad}
      />
    </div>
  );
};
